module.exports = __webpack_public_path__ + "static/media/ka-formal-poster.2baeead7.png";